import { Body } from '@assembly-js/design-system';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  one: {
    opacity: 0,
    WebkitAnimation: '$dot 1.3s infinite',
    WebkitAnimationDelay: '0.0s',
    animation: '$dot 1.3s infinite',
    animationDelay: '0.0s',
  },
  two: {
    opacity: 0,
    WebkitAnimation: '$dot 1.3s infinite',
    WebkitAnimationDelay: '0.2s',
    animation: '$dot 1.3s infinite',
    animationDelay: '0.2s',
  },
  three: {
    opacity: 0,
    WebkitAnimation: '$dot 1.3s infinite',
    WebkitAnimationDelay: '0.3s',
    animation: '$dot 1.3s infinite',
    animationDelay: '0.3s',
  },
  '@keyframes dot': {
    '0%': { opacity: 0 },
    '50%': { opacity: 0 },
    '100%': { opacity: 1 },
  },
});

const textClasses = 'font-medium leading-6';

export const AnimatedDots = () => {
  const { classes } = useStyles();

  return (
    <Body className="text-gray-small" size="sm" tag="div">
      <span className={clsx(textClasses, classes.one)}>.</span>
      <span className={clsx(textClasses, classes.two)}>.</span>
      <span className={clsx(textClasses, classes.three)}>.</span>
    </Body>
  );
};
